export const enum MediaType {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
  LINK = 'LINK',
  // this is a legacy type
  // we won't have this type on the latest data
  VIDEO_URL = 'VIDEO_URL',
}
